/**
 * Microsoft Clarity POR TENANT.
 *
 * O project ID vem SEMPRE do branding do tenant (resolvido por hostname) — build
 * único, telemetria isolada por tenant. NÃO há fallback para o env aqui: sem id,
 * não injeta nada (evita que um tenant sem Clarity caia no projeto do master —
 * vazamento de telemetria cross-tenant). A decisão de usar o env como fallback do
 * MASTER fica no chamador (main.ts), gateada por isMaster.
 *
 * Garantias:
 *  - idempotente: nunca injeta um 2º script de Clarity;
 *  - NUNCA injeta na tela de callback SSO nem enquanto o token está no fragmento
 *    da URL (o JWT chega em `#token=...` e não pode vazar para a telemetria).
 */

let clarityInjected = false;

/** Estamos numa rota/estado onde o JWT pode estar exposto no fragmento da URL? */
function isSsoTokenContext(): boolean {
    return (
        window.location.pathname === '/login/sso-callback' ||
        window.location.hash.includes('token')
    );
}

export function initClarity(projectId?: string): void {
    const id = (projectId || '').trim();
    if (!id) {
        return;
    }

    // Nunca carregar telemetria enquanto o token SSO puder estar no fragmento.
    if (isSsoTokenContext()) {
        return;
    }

    // Idempotência: se já injetamos (ou há um script de Clarity na página), aborta.
    if (clarityInjected || document.querySelector('script[src*="clarity.ms"]')) {
        clarityInjected = true;
        return;
    }

    type ClarityFn = { q?: unknown[] } & ((...args: unknown[]) => void);
    const c = window as Window & { clarity?: ClarityFn };

    c.clarity =
        c.clarity ||
        function (this: unknown, ...args: unknown[]) {
            (c.clarity!.q = c.clarity!.q || []).push(args);
        };

    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + id;
    const y = document.getElementsByTagName('script')[0];
    y.parentNode?.insertBefore(t, y);
    clarityInjected = true;
}
